<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.125 0H1.875C0.841064 0 0 0.841064 0 1.875V9.875C0 10.9089 0.841064 11.75 1.875 11.75H2.88477C3.13257 11.2798 3.45911 10.8572 3.8468 10.5H1.875C1.5304 10.5 1.25 10.2196 1.25 9.875V2.25818L8 7.27893L14.75 2.25818V9.875C14.75 10.2196 14.4696 10.5 14.125 10.5H12.625V11.75H14.125C15.1589 11.75 16 10.9089 16 9.875V1.875C16 0.841064 15.1589 0 14.125 0ZM1.98901 1.25H14.011L8 5.72107L1.98901 1.25ZM8.60193 8.36609L11.3885 11.1527L8.60193 13.9393L7.71802 13.0555L9.02344 11.75H6.99011C5.81287 11.75 4.85498 12.7078 4.85498 13.8851C4.85498 14.4305 5.13916 14.9047 5.37756 15.2063L4.39685 15.9812C3.87878 15.3258 3.60498 14.601 3.60498 13.8851C3.60498 12.0186 5.12354 10.5 6.99011 10.5H8.96802L7.71802 9.25L8.60193 8.36609Z"
      fill="#0466F9"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
